module.exports = __webpack_public_path__ + "img/image-3.dbea985b.jpg";